var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-header',{attrs:{"title":_vm.$t('dictionary.access_group')}}),_c('page-body',[_c('access-group-list',{attrs:{"id":_vm.listId}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }